import Vue from 'vue';
import Vuex from 'vuex';

import httpStatus from './modules/httpStatus';
import alertData from './modules/alertData';
import pageData from './modules/pageData';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        httpStatus,
        alertData,
        pageData,
    },
    state: {
        isDivinationOpen: false,
    },
    mutations: {
        toggleDivination(state, payload) {
            state.isDivinationOpen = payload;
        },
    },
    // 嚴格模式，禁止直接修改 state
    strict: process.env.NODE_ENV !== 'production',
});
